import { createSlice } from "@reduxjs/toolkit"
import client from "../../../lib/client"

import { associatedClientBatchesUrl, clientNamesUrl, clientReportsUrl, generateBillSummaryReportUrl, generatedReportsUrl, } from "../../../lib/endpoints"

export const adminReportsSlice = createSlice({
    name: "adminReports",
    initialState: {
        loading: false,
        adminReports: [],
        clientNames: [],
        associatedBatches: [],
        // adminReport: null,
        // assignables: [],
        pagination: { current: 1, pageSize: 10 },
    },
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setAdminReports: (state, action) => {
            state.adminReports = action.payload
        },
        setClientNames: (state, action) => {
            state.clientNames = action.payload
        },
        setAssociatedBatches: (state, action) => {
            state.associatedBatches = action.payload
        },
        setPagination: (state, action) => {
            state.pagination = action.payload
        },
    },
})

export const { setAdminReports, setLoading, setPagination, setClientNames, setAssociatedBatches } = adminReportsSlice.actions

export function fetchReports(clientId) {
    return async (dispatch, getState) => {
        dispatch(setLoading(true))

        client.get(clientReportsUrl(clientId))
            .then(({ data }) => {
                // console.log(data)
                dispatch(setAdminReports(data))
            })
            .catch((e) => {
                console.warn(e)
            })
            .finally(() => {
                dispatch(setLoading(false))
            })
    }
}

export function fetchClientNames() {
    return async (dispatch, getState) => {
        dispatch(setLoading(true))
        client
            .get(clientNamesUrl)
            .then(({ data }) => {
                dispatch(setClientNames(data))
            })
            .catch((e) => {
                console.warn(e)
            })
            .finally(() => {
                dispatch(setLoading(false))
            })
    }
}

export function fetchAssociatedClientBatches(identifiers) {
    return async (dispatch, getState) => {
        dispatch(setLoading(true))
        client
            .get(`${associatedClientBatchesUrl}?identifiers=${identifiers}`)
            .then(({ data }) => {
                dispatch(setAssociatedBatches(data))
            })
            .catch((e) => {
                console.warn(e)
            })
            .finally(() => {
                dispatch(setLoading(false))
            })
    }
}

export function generateBillSummaryReport(values) {
    return async (dispatch, getState) => {
        dispatch(setLoading(true))
        // console.log(values)

        try {
            const response = await client.post(
                `${generateBillSummaryReportUrl}?connection_id=${getState().app.uid}`,
                {
                    bill_summary_report: values,
                },
                {
                    responseType: "blob",
                }
            )

            // Create download from blob
            const url = window.URL.createObjectURL(response.data)
            const a = document.createElement("a")
            a.href = url
            a.download = `bill_summary_report_${Date.now()}.csv`
            document.body.appendChild(a) // Add to DOM for Firefox
            a.click()
            document.body.removeChild(a) // Clean up
            window.URL.revokeObjectURL(url)
        } catch (error) {
            console.error("Download failed:", error)
        } finally {
            dispatch(setLoading(false)) // Should be false, not true
        }
    }
}
export const selectReports = (state) => state.adminReports.adminReports
export const selectLoading = (state) => state.adminReports.loading
export const selectPagination = (state) => state.adminReports.pagination
export const selectClientNames = state => state.adminReports.clientNames
export const selectAssociatedBatches = state => state.adminReports.associatedBatches

export default adminReportsSlice.reducer
